import useApprovalPolicyHook from "@/hooks/use-approval-policy.hook.tsx";
import { useTitle } from "@/hooks/use-title.hook.ts";
import { ApprovalPoliciesSortModal } from "@/pages/settings/approval-policies/widget/ApprovalPoliciesSortModal.tsx";
import { useApprovalCategoryById } from "@/queries/approval/use-approval-categories.query.ts";
import analyticsService, {
  analyticEvents,
  analyticProperties,
} from "@/services/analytics-service.ts";
import { Button, Card, Page, Stack, Tag, useModals } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useEffectOnce } from "react-use";

export function ApprovalCategoryPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { data: category, isLoading } = useApprovalCategoryById(Number(id));
  const { getCategoryInfo } = useApprovalPolicyHook();
  const { openModal } = useModals();

  const locale = category ? getCategoryInfo(category) : { title: "", caption: "" };

  useTitle(locale.title, t("approval:settings_title"));

  useEffectOnce(() => {
    analyticsService.trackEvent(analyticEvents.approvals.categoryViewed, {
      [analyticProperties.id]: Number(id),
    });
  });

  return (
    <Page>
      <Page.Header
        title={locale.title}
        showBack={true}
        navigateTo={"/settings/approval-categories"}
      >
        <Button
          onClick={() =>
            openModal(ApprovalPoliciesSortModal, {
              categoryId: Number(id),
            })
          }
        >
          {t("common:reorder")}
        </Button>
      </Page.Header>
      <Page.Content>
        <Stack
          gap={"md"}
          className={"px-16 pt-4 grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-4"}
          direction={"horizontal"}
        >
          {isLoading ? (
            <Card isLoading={true} />
          ) : (
            <>
              {category?.policies.map((policy) => (
                <Card
                  header={policy.title}
                  key={policy.id}
                  to={`/settings/approval-categories/${id}/policies/${policy.id}`}
                  buttonsSlot={
                    <Tag>
                      {t("plurals:employees_count", {
                        count: policy.employees_count ?? 0,
                      })}
                    </Tag>
                  }
                />
              ))}

              <Card
                icon={"fa-plus"}
                header={t("time_off:create_new_policy_title")}
                caption={t("approval:in_category", { category: locale.title })}
                to={`/settings/approval-categories/${id}/policies/new`}
                variant={"action"}
              />
            </>
          )}
        </Stack>
      </Page.Content>
    </Page>
  );
}
